module.exports = __webpack_public_path__ + "img/js.3fc874a8.svg";